<template>
  <div>
    <b-button-group class="float-sm-left" size="sm">
      <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/dmPipeline.vue" target="_blank" style="color:black">
        <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
      </a>
      <b-button v-b-modal.intensity-dm-pipeline-modal>Rerun DM Pipeline</b-button>
      <b-button variant="info" href="https://frb.chimenet.ca/workflow/buckets/intensity-dm-pipeline" target="_blank">Monitor Job in Workflow Web</b-button>
      <b-button variant="success" href="https://frb.chimenet.ca/workflow/results/intensity-dm-pipeline" target="_blank">Check Job Results</b-button>
    </b-button-group>
    <b-button variant="dark" size="sm" @click="unsaveParameters('intensity-dm-pipeline')">UnSave Results</b-button>
    <b-button variant="success" size="sm" @click="saveParameters('intensity-dm-pipeline')">Save Results</b-button>
    <b-button variant="danger" size="sm" @click="flagParameters('intensity-dm-pipeline')">Flag for Pipeline Expert</b-button>
    <b-button class = "float-sm-right" variant="warning" size="sm" @click="badParameters('intensity-dm-pipeline')">Bad Data</b-button>
    <p v-if="rerunIntensityDM === true" style="color: green">
        Intensity DM pipeline job was successfully deployed for this event.
    </p>
    <div v-for="(round, index) in intensityDmPipelineItems" :key="index" style="margin-top: 50px;">
      <h4> Last Processed on: {{ round['processedAt'] }}</h4>
      <b-row v-if="round['fitData'] != 0">
        <b-row>
        <b-col md="4">
          <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['snr_waterfall']}`"/>
        </b-col>
        <b-col md="4">
          <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['structure_waterfall']}`"/>
        </b-col>
        <b-col md="4" style="margin-top: 90px">
            <b-row style="margin-bottom: 15px">
              <b>DM Pipeline Parameters:</b>
            </b-row>
            <table border="0">
              <tr align="left">
                <td> Time (UTC @ 400 MHz): </td>
                <td> {{ round['fitData']['datetime'] }}</td>
              </tr>
              <tr align="left">
                <td>  SNR :</td>
                <td> {{ round['fitData']['snr'] }} </td>
              </tr>
              <tr align="left">
                <td>  Pulse Width (s): </td>
                <td> {{ round['fitData']['width'] }} </td>
              </tr>
              <tr align="left">
                <td> DM (best snr): </td>
                <td> {{ round['fitData']['dm_snr'] }} +/- {{ round['fitData']['dm_snr_error'] }} </td>
              </tr>
              <tr align="left">
                <td> DM (best structure): </td>
                <td> {{ round['fitData']['dm_structure'] }} +/- {{ round['fitData']['dm_structure_error'] }} </td>
              </tr>
              <tr align="left">
                <td> Per-beam Lower Frequencies (MHz): </td>
                <td> {{ round['fitData']['bw_low_frequencies_mhz'] }} </td>
              </tr>
              <tr align="left">
                <td> Per-beam Upper Frequencies (MHz): </td>
                <td> {{ round['fitData']['bw_high_frequencies_mhz'] }} </td>
              </tr>
              <tr align="left">
                <td> Multi-beam Bandwidth (MHz): </td>
                <td> {{ round['fitData']['mb_bandwidth_mhz'] }} </td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <details style="text-center">
            <summary>Show Diagnostic Plots</summary>
            <b-row>
              <b-col md="2">
              </b-col>
              <b-col md="4">
                <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['boxcar_convolution']}`"/>
              </b-col>
              <b-col md="4">
                <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['boxcar_convolution_profiles']}`"/>
              </b-col>
              <b-col md="2">
              </b-col>
              </b-row>
              <b-row>
              <b-col md="2">
              </b-col>
              <b-col md="4">
                <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['dm_search']}`"/>
              </b-col>
              <b-col md="4">
                <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['5sig']}`"/>
              </b-col>
              <b-col md="2">
              </b-col>
              </b-row>
              <b-row>
              <b-col md="2">
              </b-col>
              <b-col md="4">
                <b-img-lazy fluid v-bind:src="`https://frb.chimenet.ca/frb-master/v1/events/query-file?filename=${round['all_beams']}`"/>
              </b-col>
              <b-col md="2">
              </b-col>
              </b-row>

            </details>
          </b-row>
      </b-row>
    </div>
  </div>
</template>

<script>
export default{
  props: [
    'rerunIntensityDMPipeline',
    'rerunIntensityDM',
    'unsaveParameters',
    'saveParameters',
    'flagParameters',
    'badParameters',
    'intensityDmPipelineItems'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/dmPipeline.vue